import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ICLEARUser } from '@app/shared/interfaces/ICLEARUser';
import { ɵk } from '@dustwhirl/ng-esri-jsapi-map';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import {
  environment as env,
  environment,
} from '../../../environments/environment';
import { ApiService } from './api.service';
import { JwtService } from './jwt.service';

@Injectable({
  providedIn: 'root',
})
export class EsriAuthService {
  public globalToken: BehaviorSubject<string> = new BehaviorSubject(null);
  constructor(
    public mapLibAuthService: ɵk,
    public http: HttpClient,
    public router: Router,
    private jwt: JwtService,
    private api: ApiService
  ) {}

  async checkSignIn() {
    // tslint:disable-next-line: triple-equals
    // if (sessionStorage.getItem('Unauthorized') == 'true') {
    //   this.router.navigateByUrl('/unauthorized');
    //   return false;
    // }

    return await this.mapLibAuthService
      .setPortal(env.portalUrl, [])
      .then(async (res) => {
        const authFailed = this.mapLibAuthService.didLastPortalLoadFail();
        const portalToken = sessionStorage.getItem('PortalToken');
        const credentials = sessionStorage.getItem('EnteredCredentials');
        if (portalToken) return true;
        return false;
      });
  }

  async setPortal() {
    return await this.mapLibAuthService
      .setPortal(env.portalUrl, [])
      .then(async () => {});
  }

  async signIn() {
    sessionStorage.setItem('EnteredCredentials', 'true');
    await this.loadPortal()
      .then((obj) => {
        sessionStorage.setItem('UserName', obj.credential.userId);
        if (!obj.err && this.isAuthorizedUser(obj)) {
        } else {
          sessionStorage.setItem('Unauthorized', 'true');
          sessionStorage.setItem('EnteredCredentials', 'false');
        }
      })
      .catch((err) => {
        console.warn('Portal not loaded', err);
      });
  }

  didAuthFail() {
    return this.mapLibAuthService.didLastPortalLoadFail();
  }

  isAuthorizedUser(obj) {
    const groups = obj.groups.map((x) => (x = x.toUpperCase()));
    if (obj.groups) {
      sessionStorage.setItem('Groups', obj.groups);

      if (groups.includes('CLEAR_ADMIN') || groups.includes('SAFETY_ADMIN')) {
        sessionStorage.setItem('accountType', 'admin');
      } else {
        sessionStorage.setItem('accountType', 'user');
      }
      return (
        groups.includes('SAFETY_USER') || groups.includes('SAFETY_DESIGNER')
      );
    } else {
      return false;
    }
  }

  async loadPortal() {
    try {
      const portal = await this.mapLibAuthService.loadPortal(
        env.portalUrl,
        env.portalAppId,
        'immediate',
        false
      );
      const credential = await this.mapLibAuthService.checkSignInStatus(
        env.portalUrl
      );
      const username = credential.userId;
      const token = credential.token;
      sessionStorage.setItem('PortalToken', credential.token);
      await this.jwt.generateToken(token);
      const userName = sessionStorage.getItem('UserName');
      this.fetchUser();
      this.globalToken.next(credential.token);
      const groups = await this.getGroups(username, token);
      return { portal, credential, groups };
    } catch (err) {
      return err;
    }
  }

  private fetchUser(): Promise<void> {
    const userName = sessionStorage.getItem('UserName');
    return this.api
      .getUserByName(userName)
      .toPromise()
      .then((user: ICLEARUser) => {
        sessionStorage.setItem('UserID', user.CLEARUserID.toString());
        return;
      })
      .catch((err) => {
        console.log('Error Getting UserName Info');
      });
  }

  async getGroups(username: string, token: string) {
    return await this.http
      .get(
        `${env.portalUrl}/sharing/rest/community/users/${username}?f=json&token=${token}`
      )
      .toPromise()
      .then((res: any) => {
        return res.groups.map((group: any) => group.title);
      })
      .catch((err) => {
        console.warn(err);
        return null;
      });
  }

  async signOut() {
    try {
      this.mapLibAuthService.srvcEsriId.destroyCredentials();
    } catch (err) {
      console.warn(err);
    } finally {
      this.http
        .get(env.portalSignOut, { responseType: 'text' })
        .toPromise()
        .then(() => this.reloadApp())
        .catch((err) => console.log('Error signing out', err));
    }
  }

  reloadApp() {
    sessionStorage.removeItem('PortalToken');
    sessionStorage.removeItem('GlobalToken');
    sessionStorage.removeItem('EnteredCredentials');
    sessionStorage.removeItem('Unauthorized');
    sessionStorage.removeItem('esriJSAPIOAuth');
    sessionStorage.removeItem('AccountType');
    sessionStorage.removeItem('UserName');
    sessionStorage.removeItem('Groups');
    this.router.navigateByUrl('/landing').then(() => {
      window.location.reload();
    });
  }
}
